import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "dialogHeader" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "blueBar" }, null, -1)
const _hoisted_3 = ["id"]

import {transformI18n} from '@/langs/i18n';
import {
  nextTick, reactive, ref,
  watch,
} from 'vue';
import {versionGET} from '@/api/user';
import {FormInstance} from 'element-plus';

interface stateType {
  version: string,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'versionInfoDialog',
  props: {
  visible: {
    type: Boolean,
    default: false,
  },
},
  emits: ['update:visible'],
  setup(__props, { emit }) {

const props = __props;





const ruleFormRef = ref<FormInstance>();

const defaultForm = {
  version: '',
};

const form = reactive<stateType>({
  ...defaultForm,
});

watch(() => props.visible, (newValue) => {
  if (newValue) {
    Object.assign(form, {
      ...defaultForm,
    });
    getVersion();
    setTimeout(() => {
      ruleFormRef.value?.clearValidate();
    });
  }
});

const handlerClose = () => {
  updateVisible();
};

const updateVisible = () => {
  emit('update:visible', false);
};

const getVersion = async () => {
  try {
    const res = await versionGET();
    form.version = res.data.version;
  } catch (e) {
    // do nothing.
  }
};

return (_ctx: any,_cache: any) => {
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "model-value": __props.visible,
    "onUpdate:visible": updateVisible,
    onClose: handlerClose
  }, {
    header: _withCtx(({titleId, titleClass}) => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("span", {
          id: titleId,
          class: _normalizeClass(titleClass)
        }, _toDisplayString(_unref(transformI18n)('user.versionInfo')), 11, _hoisted_3)
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        ref_key: "ruleFormRef",
        ref: ruleFormRef,
        model: form,
        size: "default",
        "label-position": "right",
        "label-width": "180px",
        style: {"width":"80%"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: _unref(transformI18n)('common.version'),
            prop: "version"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(form.version), 1)
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})